export interface FileDownloadItem {
  url: string;
  fileName?: string;
}

/**
 * Download a single file using a Blob to ensure the browser always triggers a download.
 */
export const downloadFile = async (url: string, fileName?: string): Promise<void> => {
  if (!url) {
    return;
  }

  try {
    const response = await fetch(url, {
      credentials: "include"
    });

    if (!response.ok) {
      throw new Error(`Failed to download file. Status: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName ?? "";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch {
    // Fallback: open original URL in a new tab if Blob download fails.
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

/**
 * Download multiple files sequentially.
 */
export const downloadMultipleFiles = async (items: FileDownloadItem[]): Promise<void> => {
  for (const item of items) {
    // eslint-disable-next-line no-await-in-loop
    await downloadFile(item.url, item.fileName);
  }
};
